package it.maicol07.gamerlogue

import androidx.compose.ui.text.intl.Locale
import kotlin.String
import kotlin.collections.Map

internal object BuildConfig {
  internal val APP_ENV: AppEnvironment = AppEnvironment.PRODUCTION

  internal val AVAILABLE_LANGUAGES: Map<String, Locale> =
      mapOf("en" to Locale("en"), "it" to Locale("it"))
}
